var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.length
    ? _c("section", { staticClass: "home-page-people" }, [
        _c(
          "div",
          { staticClass: "home-page-people__body" },
          [
            _c(
              "z-caption",
              {
                staticClass: "u-bottom-margin--xl-important",
                attrs: {
                  tag: "h2",
                  size: "xl",
                  theme: "white",
                  href: "/" + _vm.$root.lang + "/career/team/",
                  uppercase: "",
                },
              },
              [_c("span", { domProps: { innerHTML: _vm._s(_vm.text.title) } })]
            ),
            _vm._v(" "),
            _c(
              "slider",
              {
                staticClass: "home-page-people__slider",
                attrs: { autoplay: "", loop: "" },
              },
              _vm._l(_vm.data, function (item, index) {
                return _c(
                  "slide",
                  { key: index },
                  [
                    _c("z-blockquote", {
                      attrs: {
                        size: "l",
                        author: {
                          name: item.name,
                          info: item.position.value,
                          photo: item.previewPicture.link,
                        },
                        text: item.quote.value,
                        date: item.activeFrom
                          ? _vm.$options.filters.momentFilter(
                              item.activeFrom,
                              "DD MMMM YYYY"
                            )
                          : "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "home-page-people__links" },
                                  [
                                    _c(
                                      "z-link",
                                      {
                                        attrs: {
                                          size: "l",
                                          href: item.detailPageUrl,
                                          internal: "",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.text.historyOfSuccess
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "z-link",
                                      {
                                        attrs: {
                                          size: "l",
                                          href:
                                            "/" +
                                            _vm.$root.lang +
                                            "/career/why-raspadskaya/",
                                          internal: "",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(_vm.text.whyRasp),
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }